import { PrescriptionPlanningStatus } from './prescription.interface';

export const NO_ACHI_CODE: string = 'NO ACHI';
export const GUARANTEE_REASON_UNKNOWN: string = 'Причина статусу невідома';
export const EDIT_BLOCKING_PLANNING_STATUSES = new Set([
  PrescriptionPlanningStatus.Planned,
  PrescriptionPlanningStatus.Completed,
  PrescriptionPlanningStatus.PendingCreation,
  PrescriptionPlanningStatus.PendingReschedule,
  PrescriptionPlanningStatus.PendingCancellation,
]);
